import { h, render, Component, createRef } from 'preact';
import { classNames, checkRequiredInvalid, checkUsPlusOnePhoneInvalid, checkEmail, normalizeToUsPlusOnePhone } from '../utils/utils';
import { appConfig } from '../app.config';
import axios from 'axios';
import TxrInput from './txr-input';
import TxrPhoneInput from './txr-phone-input';
import TxrDropdown from './txr-dropdown';
import { HubspotService } from '../hubspot.service';

class TxrPurchaseAccountForm extends Component {
    state = {
        isSubmitted: false,
        invalid: false,
        isLoading: false,
        errorMessage: undefined,
        emailError: undefined,
        purchased: false,
        errors: {
            required: 'Required field',
            email: 'Please enter a valid e-mail',
            duplicateEmail: 'This email is already in use.',
            phone: 'Use a North American number in the form +1 followed by 10 digits (example: +15551234567).',
            maxLength: 'The maximum length is 20 characters'
        },
        useCases: [
            { title: 'Customer Service', id: 0 },
            { title: 'Lead Generation', id: 4 },
            { title: 'Fundraising', id: 2 },
            { title: 'Marketing & Promotions', id: 5 },
            { title: 'Partner', id: 6 },
            { title: 'Political', id: 7 },
            { title: 'Sales', id: 9 },
            { title: 'Reviews & Feedback', id: 8 },
            { title: 'Scheduling', id: 10 },
            { title: 'Updates & Notifications', id: 12 }
            /*
            { title: 'Employee & Internal Communications', id: 1 },
            { title: 'General Communications', id: 3 },
            { title: 'Staffing & HR', id: 11 },
             */
            
        ],
        companySizes: [
            { title: '1-50', id: 0 },
            { title: '51-200', id: 1 },
            { title: '201-500', id: 2 },
            { title: '501-1,000', id: 3 },
            { title: '1,001+', id: 4 }
        ],
        industries: [
            { title: 'Associations & Member Groups', id: 0 },
            { title: 'Automotive', id: 1 },
            { title: 'Education', id: 2 },
            { title: 'Financial Services', id: 3 },
            { title: 'Fitness & Wellness', id: 4 },
            { title: 'Home Services & Contractors', id: 5 },
            { title: 'Hospitality', id: 6 },
            { title: 'Logistics', id: 7 },
            { title: 'Marketing & Advertising', id: 8 },
            { title: 'Medical', id: 9 },
            { title: 'Nonprofit', id: 10 },
            { title: 'Political', id: 11 },
            { title: 'Professional Services', id: 12 },
            { title: 'Retail', id: 13 },
            { title: 'Software, IT & Telecom', id: 14 },
            { title: 'Other', id: 100 },
        ],
        firstNameModel: {
            value: '',
            invalid: false,
            errors: {},
            change: (model, skipPrepurchase) => {
                let maxLength = model.value && model.value.length > 20;
                model.errors['maxLength'] = maxLength;
                const hasError = maxLength || checkRequiredInvalid(model, this.state.isSubmitted);
                model.invalid = hasError && this.state.isSubmitted;
                this.state.invalid = this.state.invalid || model.invalid;
                this.forceUpdate();
                if(skipPrepurchase) {
                    return;
                }
                this.delayedPrepurchaseRequest();
            }
        },
        lastNameModel: {
            value: '',
            invalid: false,
            errors: {},
            change: (model, skipPrepurchase) => {
                let maxLength = model.value && model.value.length > 20;
                model.errors['maxLength'] = maxLength;
                const hasError = maxLength || checkRequiredInvalid(model, this.state.isSubmitted);
                model.invalid = hasError && this.state.isSubmitted;
                this.forceUpdate();
                if(skipPrepurchase) {
                    return;
                }
                this.delayedPrepurchaseRequest();
            }
        },
        companyModel: {
            value: '',
            invalid: false,
            errors: {},
            change: (model, skipPrepurchase) => {
                const hasError = checkRequiredInvalid(model, this.state.isSubmitted);
                model.invalid = hasError && this.state.isSubmitted;
                this.forceUpdate();
                if(skipPrepurchase) {
                    return;
                }
                this.delayedPrepurchaseRequest();
            }
        },
        emailModel: {
            value: '',
            invalid: false,
            errors: {},
            change: (model, skipPrepurchase) => {
                this.state.emailError = false;
                const hasError = !this.state.purchased && (checkRequiredInvalid(model, this.state.isSubmitted) || checkEmail(model, this.state.isSubmitted));
                model.invalid = hasError && this.state.isSubmitted;
                this.forceUpdate();
                if(skipPrepurchase) {
                    return;
                }
                this.delayedPrepurchaseRequest();
            }
        },
        phoneModel: {
            value: '',
            invalid: false,
            errors: {},
            change: (model, skipPrepurchase) => {
                const hasError = checkRequiredInvalid(model, this.state.isSubmitted) || checkUsPlusOnePhoneInvalid(model, this.state.isSubmitted);
                model.invalid = hasError && this.state.isSubmitted;
                this.forceUpdate();
                if(skipPrepurchase) {
                    return;
                }
                this.delayedPrepurchaseRequest();
            }
        },
        companySizeModel: {
            value: '',
            invalid: false,
            errors: {},
            change: (model, skipPrepurchase) => {
                this.forceUpdate();
                if(skipPrepurchase) {
                    return;
                }
                this.delayedPrepurchaseRequest();
            }
        },
        useCaseModel: {
            value: '',
            invalid: false,
            errors: {},
            change: (model, skipPrepurchase) => {
                this.forceUpdate();
                if(skipPrepurchase) {
                    return;
                }
                this.delayedPrepurchaseRequest();
            }
        },
        webSiteUrlModel: {
            value: '',
            invalid: false,
            errors: {},
            change: (model, skipPrepurchase) => {
                const hasError = checkRequiredInvalid(model, this.state.isSubmitted);
                model.invalid = hasError && this.state.isSubmitted;
                this.forceUpdate();
                if(skipPrepurchase) {
                    return;
                }
                this.delayedPrepurchaseRequest();
            }
        },
        /*
        industryModel: {
            value: '',
            invalid: false,
            errors: {},
            change: (model) => {
                this.forceUpdate();
                this.delayedPrepurchaseRequest();
            }
        },
        industryOtherModel: {
            value: '',
            invalid: false,
            errors: {},
            change: (model) => {
                this.forceUpdate();
                this.delayedPrepurchaseRequest();
            }
        },
        */

    }
    refCompanySizes = createRef();
    refUseCases = createRef();
    refIndustries = createRef();

    validate(skipPrepurchase) {
        this.state.firstNameModel.change(this.state.firstNameModel, skipPrepurchase);
        this.state.lastNameModel.change(this.state.lastNameModel, skipPrepurchase);
        this.state.companyModel.change(this.state.companyModel, skipPrepurchase);
        this.state.phoneModel.change(this.state.phoneModel, skipPrepurchase);
        this.state.companySizeModel.change(this.state.companySizeModel, skipPrepurchase);
        this.state.useCaseModel.change(this.state.useCaseModel, skipPrepurchase);
        this.state.webSiteUrlModel.change(this.state.webSiteUrlModel, skipPrepurchase);
    }
    isInvalid() {
        return this.state.firstNameModel.invalid ||
            this.state.lastNameModel.invalid ||
            this.state.companyModel.invalid ||
            (this.state.emailModel.invalid) ||
            this.state.phoneModel.invalid ||
            this.state.companySizeModel.invalid ||
            this.state.useCaseModel.invalid ||
            this.state.webSiteUrlModel.invalid;
    }
    componentDidMount() {
        this.props.refresh.accountFormRefresh = (accountInfo) => {
            this.state.firstNameModel.value = accountInfo.firstName;
            this.state.lastNameModel.value = accountInfo.lastName;
            this.state.companyModel.value = accountInfo.company;
            this.state.phoneModel.value = accountInfo.phone;
            this.state.emailModel.value = accountInfo.email;
            this.state.companySizeModel.value = this.state.companySizes.find(f => f.id == accountInfo.companySize);
            this.state.useCaseModel.value = this.state.useCases.find(f => f.id == accountInfo.useCase);
            this.state.webSiteUrlModel.value = accountInfo.webSiteUrl;
            /*
            this.state.industryModel.value = this.state.industries.find(f => f.id == accountInfo.industry);
            this.state.industryOtherModel.value = accountInfo.otherIndustry;
            */
            this.forceUpdate();
            return !this.isInvalid();
        };
         this.props.refresh.submitEvent = () => {
            this.state.purchased = true;
            this.state.emailError = false;
            this.state.isSubmitted = true;
            this.setState({ isSubmitted: true });
            this.state.invalid = false
             this.forceUpdate();
         };
    }

    getErrorsForForm() {
        if (!this.props.trial) {
            return this.state.errors;
        }
        return {
            ...this.state.errors,
            duplicateEmail: (
                <span>
                    This email is in use with our free trial.{' '}
                    <a class="txr-text__link" href="https://app.textrequest.com/app/login">
                        Please log in to continue
                    </a>
                    .
                </span>
            )
        };
    }
    delayedPrepurchaseRequest() {
        if(this.state.purchased) {
            return;
        }
        if (this.delayedPrepurchaseRequestTimer) {
            clearTimeout(this.delayedPrepurchaseRequestTimer);
        }
        this.delayedPrepurchaseRequestTimer = setTimeout(() => {
            this.delayedPrepurchaseRequestTimer = null;
            this.prepurchaseRequestImpl();
        }, 3000);
    }

    prepurchaseRequestImpl() {
          return this.prepurchaseRequest()
            .then((response) => {
                this.setState({ emailError: false });
            })
            .catch((e) => {
                if (e.response.data && e.response.data) {
                    if (e.response.status == 409) {
                        this.state.emailError = true;
                        this.setState({ emailMessage: e.response.data.message });
                        this.state.emailModel.invalid = !!this.state.emailError;
                        this.state.emailModel.errors['duplicateEmail'] = !!this.state.emailError;
                        this.forceUpdate();
                    }
                } 
            });
    }
    createData() {
        const data =
        {
            prepurchaseId: this.props.prepurchaseId,
            firstName: this.state.firstNameModel.value,
            lastName: this.state.lastNameModel.value,
            company: this.state.companyModel.value,
            phone: normalizeToUsPlusOnePhone(this.state.phoneModel.value) || this.state.phoneModel.value,
            email: this.state.emailModel.value,
            companySize: this.state.companySizeModel.value ? this.state.companySizeModel.value.id : null,
            useCase: this.state.useCaseModel.value ? this.state.useCaseModel.value.id : null,
            webSiteUrl: this.state.webSiteUrlModel.value,
            //industry: this.state.industryModel.value ? this.state.industryModel.value.id : null,
            //otherIndustry: this.state.industryOtherModel.value,
            planId: this.props.plan?.planId
        };
        return data;

    }
    toggleDropdowns(e) {
        if (e !== this.refCompanySizes) {
            this.refCompanySizes.current.close();
        }
        if (e !== this.refUseCases) {
            this.refUseCases.current.close();
        }
        /*
        if (e !== this.refIndustries) {
            this.refIndustries.current.close();
        }
        */

    }
    prepurchaseRequest() {

        const data = this.createData();
        localStorage.setItem(appConfig.prepurchaseAccountInfoId, JSON.stringify(data));

        const url = appConfig.url + '/webservices/account/prepurchase';
        const options = {
            method: 'POST',
            headers: { 'content-type': 'application/json; charset=utf-8' },
            data: JSON.stringify(data),
            url,
        };
        return axios(options);
    }
    isInvalidAsync() {
        return this.prepurchaseRequestImpl()
        .then(() => {
            return this.isInvalid();
        });
    }
    continue = (e) => {
        this.state.emailError = false;
        this.state.isSubmitted = true;
        this.setState({ isSubmitted: true });

        if(!this.props.trial) {
            this.state.invalid = false
            this.state.firstNameModel.change(this.state.firstNameModel);
            this.state.lastNameModel.change(this.state.lastNameModel);
            this.state.companyModel.change(this.state.companyModel);
            this.state.emailModel.change(this.state.emailModel);
            this.state.phoneModel.change(this.state.phoneModel);
            this.state.companySizeModel.change(this.state.companySizeModel);
            this.state.useCaseModel.change(this.state.useCaseModel);
            this.state.webSiteUrlModel.change(this.state.webSiteUrlModel);
            //this.state.industryModel.change(this.state.industryModel);
            //this.state.industryOtherModel.change(this.state.industryOtherModel);
        }
        if (this.isInvalid()) {
            return;
        }
        this.setState({ isLoading: true });
        this.setState({ errorMessage: undefined, emailError: undefined });
        
        const hubspot = new HubspotService();

        if(!this.props.trial) {
            hubspot.submitFormV3([
                {
                    name: 'firstname',
                    value: this.state.firstNameModel.value
                },
                {
                    name: 'lastname',
                    value: this.state.lastNameModel.value
                }, 
                {
                    name: 'company',
                    value: this.state.companyModel.value
                },
                {
                    name: 'email',
                    value: this.state.emailModel.value
                },
                {
                    name: 'numemployees',
                    value: this.state.companySizeModel.value?.title || ''
                },
                {
                    name: 'phone',
                    value: normalizeToUsPlusOnePhone(this.state.phoneModel.value)
                },
                {
                    name: 'use_case',
                    value: this.state.useCaseModel.value?.title  || ''
                },
                {
                    name: 'website',
                    value: this.state.webSiteUrlModel.value
                },   
            ], appConfig.hubspotSignupFormId);
        }
        else {
            hubspot.submitFormV3([
                {
                    name: 'firstname',
                    value: this.state.firstNameModel.value
                },
                {
                    name: 'lastname',
                    value: this.state.lastNameModel.value
                }, 
                {
                    name: 'company',
                    value: this.state.companyModel.value
                },
                {
                    name: 'email',
                    value: this.state.emailModel.value
                },
                {
                    name: 'numemployees',
                    value: this.state.companySizeModel.value?.title || ''
                },
                {
                    name: 'phone',
                    value: normalizeToUsPlusOnePhone(this.state.phoneModel.value)
                },
                {
                    name: 'use_case',
                    value: this.state.useCaseModel.value?.title  || ''
                },
                {
                    name: 'website',
                    value: this.state.webSiteUrlModel.value
                },   
            ], appConfig.hubspotFreeTrialFormId);
        }

        if(this.props.trial) {
            return;
        }
        this.prepurchaseRequest()
            .then((response) => {
                this.setState({ isLoading: false });
                if(this.props.onContinue) {
                    this.props.onContinue(this.createData());
                }
            })
            .catch((e) => {
                this.setState({ isLoading: false });
                if (e.response.data && e.response.data) {
                    if (e.response.status == 409) {
                        this.setState({ emailError: e.response.data.message });
                        this.state.emailError = true;
                        this.state.emailModel.invalid = !!this.state.emailError;
                        this.state.emailModel.errors['duplicateEmail'] = !!this.state.emailError;
                        this.forceUpdate();
                    } else {
                        this.setState({ errorMessage: e.response.data.message });
                    }
                } else {
                    this.setState({ errorMessage: e.response.status });
                }
            })
        setTimeout(() => {
            this.setState({ isLoading: false });


        }, 1000);


    }
    onSubmit = e => {
        return false;
      }

    render() {
        const errors = this.getErrorsForForm();
        return (
            <div class="txr-purchase-account-form">
                {
                !this.props.trial && <form onsubmit={this.onSubmit} class="account__form">
                    <div class="form__left">
                        <div class="form__item">
                            <TxrInput model={this.state.firstNameModel} type="text" label="First name*" errors={errors}> </TxrInput>
                        </div>
                        <div class="form__item">
                            <TxrInput model={this.state.lastNameModel} type="text" label="Last name*" errors={errors}> </TxrInput>
                        </div>
                        <div class="form__item">
                            <TxrInput model={this.state.companyModel} type="text" label="Company*" errors={errors}></TxrInput>
                        </div>
                        <div class="form__item">
                            <TxrInput model={this.state.emailModel} type="email" label="Email*" errors={errors}></TxrInput>
                        </div>
                        <div class="form__item">
                            <TxrPhoneInput model={this.state.phoneModel} type="text" label="Phone*" normalizeChangeArgs={[true]} errors={errors}></TxrPhoneInput>
                        </div>
                    </div>
                    <div class="form__right">
                        <div class="form__item">
                            <TxrInput model={this.state.webSiteUrlModel} type="text" label="Website URL" errors={errors}> </TxrInput>
                        </div>
                        <div class="form__item txr-mb20">
                            <TxrDropdown model={this.state.companySizeModel} label="Company Size" options={this.state.companySizes} ref={this.refCompanySizes} onToogle={() => this.toggleDropdowns(this.refCompanySizes)}></TxrDropdown>
                        </div>
                        <div class="form__item txr-mb20">
                            <TxrDropdown model={this.state.useCaseModel} label="Use Case" options={this.state.useCases} ref={this.refUseCases} onToogle={() => this.toggleDropdowns(this.refUseCases)}></TxrDropdown>
                        </div>
                    </div>
                    </form>
                }
                {
                !!this.props.trial && <form onsubmit={this.onSubmit} class="account__form">
                    <div class="form__left">
                        <div class="form__item">
                            <TxrInput model={this.state.firstNameModel} type="text" label="First name*" errors={errors}> </TxrInput>
                        </div>
                        <div class="form__item">
                            <TxrInput model={this.state.lastNameModel} type="text" label="Last name*" errors={errors}> </TxrInput>
                        </div>
                        <div class="form__item">
                            <TxrPhoneInput model={this.state.phoneModel} type="text" label="Phone*" normalizeChangeArgs={[true]} errors={errors}></TxrPhoneInput>
                        </div>
                        <div class="form__item">
                            <TxrInput model={this.state.emailModel} type="email" label="Email*" errors={errors}></TxrInput>
                        </div>
                        <div class="form__item">
                            <TxrInput model={this.state.companyModel} type="text" label="Company*" errors={errors}></TxrInput>
                        </div>
                        <div class="form__item">
                            <TxrInput model={this.state.webSiteUrlModel} type="text" label="Website URL" errors={errors}> </TxrInput>
                        </div>
                        <div class="form__item txr-mb20">
                            <TxrDropdown model={this.state.companySizeModel} label="Company Size" options={this.state.companySizes} ref={this.refCompanySizes} onToogle={() => this.toggleDropdowns(this.refCompanySizes)}></TxrDropdown>
                        </div>
                        <div class="form__item txr-mb20">
                            <TxrDropdown model={this.state.useCaseModel} label="Use Case" options={this.state.useCases} ref={this.refUseCases} onToogle={() => this.toggleDropdowns(this.refUseCases)}></TxrDropdown>
                        </div>
                    </div>
                    </form>
                }                
                {this.state.errorMessage &&
                    <div class="form__error">
                        <div class="form-error__title">Operation Failed</div>
                        <div class="form-error__text">{this.state.errorMessage}</div>
                    </div>
                }
                {
                !this.props.trial && <div class="account-form__button">
                    <button class="txr-button txr-primary-button txr-width130" disabled={this.isInvalid() && this.state.isSubmitted} type="button" onClick={() => this.continue()}>
                        <span class="txr-button__content"> CONTINUE
                            {!this.state.isLoading && <i class="txr-button__angle-icon fal fa-angle-right"></i>}
                            {this.state.isLoading && <i class="txr-button__spin-icon fas fa-circle-notch fa-spin"></i>}
                        </span>
                    </button>
                </div>
                }

            </div>
        )
    }
}
export default TxrPurchaseAccountForm;